// Maps a card-platform crypto currency (symbol + network) to the vault currency
// code that shares its chain, or null when the vault does not support it.
// Mirrors the bot's server-side resolution so the UI shows the "from Vault"
// path only for currencies the transfer will actually accept.
export const cardCurrencyToVault = (symbol: string, network: string): string | null => {
  const s = symbol.trim().toUpperCase();
  const n = network.trim().toUpperCase();
  if (n.includes('TRON') || n.includes('TRC')) {
    if (s === 'USDT') return 'TRX_USDT';
    if (s === 'TRX') return 'TRX';
  }
  return null;
};

// A stable key for one logical top-up. Generated when the send screen opens and
// reused across retries so a double-tap or a retry after a timeout results in
// at most one on-chain transfer (the wallet service is idempotent on this key).
export const newIdempotencyKey = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for WebViews without crypto.randomUUID.
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};
